import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex" }

import { onMounted, ref, PropType, onActivated } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { listByParamCodes } from '@/api/common'
import { clueDetail, clueAdd, clueEdit, parentLabelList, clueTrackDetail } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import { DropListType } from '@/typings/common'
import { message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { goBack } from '@/hooks/cosRouter'
import { paramCodesDataFilter } from '@/utils/index'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'

const __default__ = { name: 'BaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  view: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  },
  hideOk: {
    type: Boolean,
    default: false
  },
  content: {
    type: Object as PropType<'base' | 'contact' | 'business' | 'launch'[]>,
    default: () => {
      return ['base', 'contact', 'business']
    }
  },
  permissionPage: {
    type: Object
  }
},
  emits: ['fetchLaunch', 'detail'],
  setup(__props, { expose: __expose, emit: __emit }) {

const route = useRoute()

const emit = __emit
const props = __props
const acceptor = ref('cos_lbu')
const init: ClueManage = {
  customerTag: [],
  business: {
    cargoType: [],
    salePlatform: [],
    warehouse: [],
    monthSales: [],
    serviceNeeds: [],
    cooperation: []
  },
  expectPushInfo: [{}],
  contact: {},
  launch: {},
  track: {}
}
const form = ref<ClueManage>(cloneDeep(init))
const resetValue = ref<ClueManage>(cloneDeep(init))
const formRef = ref()
const loading = ref(false)
const tagLIst = ref<DropListType>([])
const paramCodeData = ref<any>({
  zbu_source_channel_lbu: [], // 线索来源渠道
  zbu_product_type_lbu: [], // 产品货型
  zbu_channel_detail_lbu: [], // 销售平台
  zbu_demand_info_lbu: [], // 需求海外仓
  zbu_monthly_sales_lbu: [], // 跨境月销售额
  zbu_service_demand_lbu: [], // 服务需求
  zbu_sales_category_lbu: []
})
const areaValidate = async (rule: Rule, value: string) => {
  if (form.value.customerOfficeName) {
    const lastArea = form.value.customerOfficeName.split('/')
    if (lastArea[lastArea.length - 1]?.includes('深圳')) {
      return Promise.reject(new Error('客户区域，深圳市必须精确到区'))
    } else {
      return Promise.resolve()
    }
  } else {
    return Promise.resolve()
  }
}
// 获取标签下拉框
const getTag = () => {
  parentLabelList().then((res) => {
    tagLIst.value = res.data
  })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_source_channel_lbu',
      'zbu_product_type_lbu',
      'zbu_channel_detail_lbu',
      'zbu_demand_info_lbu',
      'zbu_monthly_sales_lbu',
      'zbu_service_demand_lbu',
      'zbu_sales_category_lbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.view) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
// 获取基本信息详情
const fetch = () => {
  if (route.query.clueId) {
    loading.value = true
    clueDetail({
      clueId: route.query.clueId
    })
      .then((res) => {
        const { expectPushInfo } = res.data
        form.value = {
          ...res.data,
          track: res.data.track || {},
          launch: form.value.launch || {},
          expectPushInfo: expectPushInfo && expectPushInfo.length ? expectPushInfo : [{}]
        }
        emit('detail', form.value)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
__expose({
  fetch
})
const handleAddCol = () => {
  form.value.expectPushInfo.push({})
}
const handleDelCol = (arr: {}[], index: number) => {
  form.value.expectPushInfo.splice(index, 1)
}
// 获取投放信息详情
const fetchLaunch = () => {
  if (props.content.includes('launch') && route.query.id) {
    loading.value = true
    clueTrackDetail({
      cluePushTrackId: Number(route.query.id)
    })
      .then((res) => {
        form.value.launch = res.data
        emit('fetchLaunch', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

onMounted(() => {
  getTag()
  getByParamCodes()
  fetch()
  fetchLaunch()
})
onActivated(() => {
  getTag()
})
const handleSubmit = async () => {
  // 过滤预投放信息
  const expectPushInfo = form.value.expectPushInfo?.filter((item) => item.acceptor || item.region || item.follower)
  const p = {
    ...form.value,
    expectPushInfo
  }
  try {
    loading.value = true
    if (route.query.clueId) {
      await clueEdit(p)
      message.success('编辑成功')
    } else {
      await clueAdd(p)
      message.success('新增成功')
    }
    goBack()
  } catch (error) {
    loading.value = false
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "基本信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "customerName",
              label: "客户名称",
              rules: {
          required: true,
          message: '请输入'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerName) = $event)),
                  maxlength: 50,
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "来源渠道",
              name: "channel",
              rules: {
          required: true,
          message: '请选择'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: form.value.channel,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.channel) = $event)),
                      options: paramCodeData.value.zbu_source_channel_lbu,
                      cosDes: form.value.channelExplain,
                      disabled: __props.disabled,
                      view: __props.view,
                      style: {"width":"33%"}
                    }, null, 8, ["value", "options", "cosDes", "disabled", "view"]),
                    _createVNode(_component_a_form_item, {
                      style: {"width":"67%"},
                      class: "last-compact",
                      name: "channelExplain"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: form.value.channelExplain,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.channelExplain) = $event)),
                          placeholder: "请输入",
                          disabled: __props.disabled,
                          view: __props.view
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户办公地",
              name: "customerOffice",
              rules: {
          validator: areaValidate,
          trigger: 'blur'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CustomerArea), {
                  value: form.value.customerOffice,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.customerOffice) = $event)),
                  label: form.value.customerOfficeName,
                  "onUpdate:label": _cache[4] || (_cache[4] = ($event: any) => ((form.value.customerOfficeName) = $event)),
                  "change-on-select": "",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "label", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, { label: "客户类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerType,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.customerType) = $event)),
                  options: _unref(dataConfig).customerTypeEnum,
                  placeholder: "请选择",
                  "allow-clear": "",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "标签" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  mode: "multiple",
                  value: form.value.customerTag,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.customerTag) = $event)),
                  options: tagLIst.value,
                  placeholder: "请选择",
                  "allow-clear": "",
                  disabled: __props.disabled,
                  view: __props.view,
                  fieldNames: { label: 'name', value: 'name' }
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            (__props.view)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "创建时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.createTime,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.createTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.remark,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.remark) = $event)),
                  maxlength: 2000,
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "联系人信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'name'],
              rules: [
          {
            required: true,
            message: '请输入'
          },
          {
            validator: _unref(concatNameValidate)
          }
        ],
              label: "联系人名称"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.name,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.contact.name) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, { label: "性别" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contact.sex,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.contact.sex) = $event)),
                  placeholder: "请选择",
                  "allow-clear": "",
                  options: _unref(dataConfig).genderEnum,
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "角色" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contact.jobRole,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.contact.jobRole) = $event)),
                  placeholder: "请选择",
                  "allow-clear": "",
                  disabled: __props.disabled,
                  view: __props.view,
                  options: _unref(dataConfig).linkRoleTypeEnum
                }, null, 8, ["value", "disabled", "view", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'mobile'],
              label: "手机号",
              rules: [
          {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.mobile,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.contact.mobile) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'email'],
              label: "邮箱",
              rules: [
          {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.email,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.contact.email) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'wechat'],
              label: "微信号",
              rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.wechat,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.contact.wechat) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'qq'],
              label: "QQ号",
              rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.qq,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.contact.qq) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'tel'],
              label: "固定电话",
              rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.tel,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.contact.tel) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "联系人备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.contact.remark,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.contact.remark) = $event)),
                  maxlength: 2000,
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "业务信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, { label: "产品货型" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_product_type_lbu,
                  value: form.value.business.cargoType,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.business.cargoType) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "销售平台" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_channel_detail_lbu,
                  value: form.value.business.salePlatform,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.business.salePlatform) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "需求海外仓",
              name: ['business', 'warehouse']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_demand_info_lbu,
                  value: form.value.business.warehouse,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.business.warehouse) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "发货地",
              name: ['business', 'shipAddress']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.shipAddress,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.business.shipAddress) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "销售品类" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_sales_category_lbu,
                  value: form.value.business.salesCategory,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.business.salesCategory) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "跨境月销售额" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_monthly_sales_lbu,
                  value: form.value.business.monthSales,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.business.monthSales) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "目的国家" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.business.destinationCountry,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.business.destinationCountry) = $event)),
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "服务需求" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.zbu_service_demand_lbu,
                  value: form.value.business.serviceNeeds,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.business.serviceNeeds) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (__props.view)
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "投放信息"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, { label: "销售线索ID" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.acceptorClueId,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.track.acceptorClueId) = $event)),
                      placeholder: "请选择",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "客户代码" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.customerNumber,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.track.customerNumber) = $event)),
                      placeholder: "请选择",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "当前跟进人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.followerName,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.track.followerName) = $event)),
                      placeholder: "请选择",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  name: "customerRegion",
                  label: "客户区域"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CustomerAreaCascader, {
                      appId: "cos_lbu",
                      value: form.value.track.customerRegion,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((form.value.track.customerRegion) = $event)),
                      view: __props.view
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "当前阶段" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.track.stage,
                      "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((form.value.track.stage) = $event)),
                      options: _unref(dataConfig).customerStageEnum,
                      placeholder: "请选择",
                      "allow-clear": "",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "当前状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.track.status,
                      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((form.value.track.status) = $event)),
                      options: _unref(dataConfig).customerAllStatusEnum,
                      placeholder: "请选择",
                      "allow-clear": "",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "投放时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.createTime,
                      "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((form.value.track.createTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "领取时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.salesCollectionTime,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((form.value.track.salesCollectionTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "转潜在时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.turnPotentialTime,
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((form.value.track.turnPotentialTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "转为成交时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.turnCustomerTime,
                      "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((form.value.track.turnCustomerTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "成交额" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.clinchAmount,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((form.value.track.clinchAmount) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "无效时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.invalidTime,
                      "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((form.value.track.invalidTime) = $event)),
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, { label: "无效原因" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.track.invalidReason,
                      "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((form.value.track.invalidReason) = $event)),
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.content.includes('expectPushInfo'))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 1,
              title: "预投放信息"
            }, {
              subTitle: _withCtx(() => [
                (!__props.view && form.value.expectPushInfo.length < 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: handleAddCol
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (!form.value.expectPushInfo || !form.value.expectPushInfo.length)
                  ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
                      key: 0,
                      type: "nothing",
                      style: {"display":"block","margin":"0 auto"}
                    }))
                  : (_openBlock(), _createBlock(MultipleItem, {
                      key: 1,
                      view: __props.view,
                      line: false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.expectPushInfo, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `expectPushInfo${index}`
                          }, [
                            _createVNode(_component_dc_form_item, {
                              label: index ? '' : '投放到',
                              class: _normalizeClass([index ? 'no-form-label' : '']),
                              span: 8
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CosSelect, {
                                  options: [
                {
                  value: 'cos_lbu',
                  label: '云途'
                }
              ],
                                  value: acceptor.value,
                                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((acceptor).value = $event)),
                                  view: __props.view
                                }, null, 8, ["value", "view"])
                              ]),
                              _: 2
                            }, 1032, ["label", "class"]),
                            _createVNode(_component_dc_form_item, {
                              label: index ? '' : '客户负责人',
                              class: _normalizeClass([index ? 'no-form-label' : '']),
                              span: 8
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_UserSelect, {
                                    value: item.follower,
                                    "onUpdate:value": ($event: any) => ((item.follower) = $event),
                                    placeholder: "请选择",
                                    allowClear: "",
                                    view: __props.view
                                  }, null, 8, ["value", "onUpdate:value", "view"]),
                                  (!__props.view)
                                    ? (_openBlock(), _createBlock(_component_a_button, {
                                        key: 0,
                                        type: "text",
                                        onClick: handleDelCol,
                                        danger: "",
                                        style: {"padding":"0 0 0 12px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("删除")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["label", "class"])
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["view"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((form).value = $event)),
          formRef: formRef.value,
          hideOk: __props.hideOk,
          resetValue: resetValue.value,
          loading: loading.value,
          permissionPage: __props.permissionPage,
          onSubmit: handleSubmit,
          disabled: __props.disabled
        }, null, 8, ["value", "formRef", "hideOk", "resetValue", "loading", "permissionPage", "disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})